// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v3.21.12
// source: completeregistration.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "completeregistration";

export interface CompleteRegistrationRequest {
  npi: string;
  name: string;
  referralType: string;
  referralName: string;
}

export interface CompleteRegistrationResponse {
}

function createBaseCompleteRegistrationRequest(): CompleteRegistrationRequest {
  return { npi: "", name: "", referralType: "", referralName: "" };
}

export const CompleteRegistrationRequest: MessageFns<CompleteRegistrationRequest> = {
  encode(message: CompleteRegistrationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.npi !== "") {
      writer.uint32(10).string(message.npi);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.referralType !== "") {
      writer.uint32(26).string(message.referralType);
    }
    if (message.referralName !== "") {
      writer.uint32(34).string(message.referralName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompleteRegistrationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompleteRegistrationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.npi = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.referralType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.referralName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompleteRegistrationRequest {
    return {
      npi: isSet(object.npi) ? globalThis.String(object.npi) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      referralType: isSet(object.referralType) ? globalThis.String(object.referralType) : "",
      referralName: isSet(object.referralName) ? globalThis.String(object.referralName) : "",
    };
  },

  toJSON(message: CompleteRegistrationRequest): unknown {
    const obj: any = {};
    if (message.npi !== "") {
      obj.npi = message.npi;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.referralType !== "") {
      obj.referralType = message.referralType;
    }
    if (message.referralName !== "") {
      obj.referralName = message.referralName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompleteRegistrationRequest>, I>>(base?: I): CompleteRegistrationRequest {
    return CompleteRegistrationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompleteRegistrationRequest>, I>>(object: I): CompleteRegistrationRequest {
    const message = createBaseCompleteRegistrationRequest();
    message.npi = object.npi ?? "";
    message.name = object.name ?? "";
    message.referralType = object.referralType ?? "";
    message.referralName = object.referralName ?? "";
    return message;
  },
};

function createBaseCompleteRegistrationResponse(): CompleteRegistrationResponse {
  return {};
}

export const CompleteRegistrationResponse: MessageFns<CompleteRegistrationResponse> = {
  encode(_: CompleteRegistrationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompleteRegistrationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompleteRegistrationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CompleteRegistrationResponse {
    return {};
  },

  toJSON(_: CompleteRegistrationResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CompleteRegistrationResponse>, I>>(base?: I): CompleteRegistrationResponse {
    return CompleteRegistrationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompleteRegistrationResponse>, I>>(_: I): CompleteRegistrationResponse {
    const message = createBaseCompleteRegistrationResponse();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
